import { useSearchParams } from "react-router-dom";
import { ActivityView } from "@/components/activity/activity-view";
import { useMemberActivity } from "@/hooks/use-member-activity";
import { isoDay, parseDayParam } from "@/lib/activity";

/** Member activity: what happened on the floors this member can reach (alarm
 *  activity) plus their company's own events, one day at a time. The backend
 *  (`GET /api/events/member/`) does all the visibility filtering. */
export default function ActivityPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const today = isoDay(new Date());
  const day = parseDayParam(searchParams.get("date"));

  const { events, isLoading, isError, refetch, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useMemberActivity(day);

  const onDayChange = (next: string) => {
    const params = new URLSearchParams(searchParams);
    if (next === today) params.delete("date");
    else params.set("date", next);
    setSearchParams(params, { replace: true });
  };

  return (
    <ActivityView
      day={day}
      today={today}
      onDayChange={onDayChange}
      events={events}
      isLoading={isLoading}
      error={isError}
      onRetry={() => void refetch()}
      hasMore={!!hasNextPage}
      isLoadingMore={isFetchingNextPage}
      onLoadMore={() => void fetchNextPage()}
    />
  );
}
